// Thème personnalisé pour le tableau de bord administrateur
import { createTheme } from '@mui/material/styles';

const adminTheme = createTheme({
    palette: {
        primary: {
            main: '#3f51b5',
            light: '#757de8',
            dark: '#002984',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#f50057',
            light: '#ff4081',
            dark: '#c51162',
            contrastText: '#ffffff',
        },
        success: {
            main: '#4caf50',
            light: '#80e27e',
            dark: '#087f23',
            contrastText: '#ffffff',
        },
        warning: {
            main: '#ff9800',
            light: '#ffc947',
            dark: '#c66900',
            contrastText: '#000000',
        },
        error: {
            main: '#f44336',
            light: '#ff7961',
            dark: '#ba000d',
            contrastText: '#ffffff',
        },
        info: {
            main: '#2196f3',
            light: '#64b5f6',
            dark: '#0069c0',
            contrastText: '#ffffff',
        },
        dashboard: {
            users: '#3f51b5',
            categories: '#f50057',
            properties: '#4caf50',
            roles: '#ff9800',
            permissions: '#f44336',
            verifications: '#2196f3',
        },
        background: {
            default: '#f5f7fa',
            paper: '#ffffff',
        },
        text: {
            primary: '#2c3e50',
            secondary: '#7f8c8d',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h4: {
            fontWeight: 600,
            fontSize: '1.75rem',
            letterSpacing: '0.02em',
        },
        h5: {
            fontWeight: 500,
            fontSize: '1.5rem',
        },
        h6: {
            fontWeight: 500,
            fontSize: '1.25rem',
            letterSpacing: '0.015em',
        },
        subtitle1: {
            fontWeight: 500,
            fontSize: '1rem',
        },
        body1: {
            fontSize: '0.95rem',
        },
        button: {
            textTransform: 'none',
            fontWeight: 500,
        },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    boxShadow: '0 2px 10px 0 rgba(0,0,0,0.08)',
                },
                elevation3: {
                    boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    overflow: 'hidden',
                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                    '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: '0 8px 24px 0 rgba(0,0,0,0.12)',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    padding: '8px 16px',
                    fontWeight: 500,
                },
                contained: {
                    boxShadow: '0 2px 6px 0 rgba(0,0,0,0.12)',
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    '&:hover': {
                        backgroundColor: 'rgba(0,0,0,0.04)',
                    },
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    margin: '8px 0',
                },
            },
        },
    },
});

export default adminTheme;